/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each column of numbers becomes one violin showing that group's distribution.`)
};

const es_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada columna de números se convierte en un violín que muestra la distribución de ese grupo.`)
};

const de_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Zahlenspalte wird zu einer Violine, die die Verteilung dieser Gruppe zeigt.`)
};

const nl_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke kolom met getallen wordt één viool die de verdeling van die groep toont.`)
};

const fr_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque colonne de nombres devient un violon montrant la distribution de ce groupe.`)
};

const it_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni colonna di numeri diventa un violino che mostra la distribuzione di quel gruppo.`)
};

const pt_br2_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada coluna de números vira um violino mostrando a distribuição daquele grupo.`)
};

const pt_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada coluna de números torna-se um violino que mostra a distribuição desse grupo.`)
};

const ja_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値の各列が、そのグループの分布を示す1つのバイオリンになります。`)
};

const zh_violin_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每一列数字变成一个小提琴，展示该组的分布。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_ex1", locale)
	if (locale === "en") return en_violin_ex1(inputs)
	if (locale === "es") return es_violin_ex1(inputs)
	if (locale === "de") return de_violin_ex1(inputs)
	if (locale === "nl") return nl_violin_ex1(inputs)
	if (locale === "fr") return fr_violin_ex1(inputs)
	if (locale === "it") return it_violin_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_violin_ex1(inputs)
	if (locale === "pt") return pt_violin_ex1(inputs)
	if (locale === "ja") return ja_violin_ex1(inputs)
	return zh_violin_ex1(inputs)
};